import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import Modal from './modal'
import { UserContext } from '../../../App'
import { FiEdit } from "react-icons/fi"
import dao from '../../../assets/img/dao.png'
import postnord from '../../../assets/img/postnord.png'
import gls from '../../../assets/img/gls.png'
import bring from '../../../assets/img/bring.png'
import { AiOutlinePlus } from "react-icons/ai";
import { LoadingFull } from '../../loading'

export const ShippingOptions = ({error, setError, pickup, setPickup, address, setAddress}) => {

  const [addresses, setAddresses] = useState([]);
  const line1Ref = useRef(null)

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'auto'})
    setError('')
  }, [])

  function updateFields(address) {
    setAddresses([])
    if (address.etage !== null) {
      if (address.dør !== null) {
        line1Ref.current.value = address.adresseringsvejnavn + ' ' + address.husnr + ', ' + address.etage + '. ' + address.dør
      } else {
        line1Ref.current.value = address.adresseringsvejnavn + ' ' + address.husnr + ', ' + address.etage + '.'
      }
    } else {
      line1Ref.current.value = address.adresseringsvejnavn + ' ' + address.husnr
    }
    document.getElementById('postal_code').value = address.postnr
    document.getElementById('city').value = address.postnrnavn
    setAddress({
      'line1': line1Ref.current.value,
      'postal_code': address.postnr,
      'city': address.postnrnavn
    })
  }

  function getAddresses(query) {
    setError('')
    if (query !== '') {
      axios.get(`https://api.dataforsyningen.dk/adresser/autocomplete?q=${query}&type=adresse`, {
      })
      .then(response => {
        setAddresses(response.data);
      })
      .catch(error => {
        console.log(error);
      });
    } else {
      setAddresses([])
    }
  }
  
  return (
    <div className="relative w-full flex flex-col gap-y-10">
      <div id="address" className="space-y-2">
        <h2 className="text-sm font-medium text-gray-900">Addresseoplysninger</h2>
        <div className="flex flex-col gap-4 ring-1 ring-neutral-300 p-4 px-5 md:px-10">
          <div className="title w-full flex flex-col gap-2">
            <p className="font-medium">Gadenavn</p>
            {(error !== '') ? <h2 className="text-sm font-medium text-red-500">{error}</h2> : ""}
            <div className="w-full relative group">
              <input type="text" onBlur={(e) => e.target.value !== address?.line1 ? e.target.value = (typeof address !== 'undefined' ? address.line1 : "") : ""} ref={line1Ref} autoComplete='none' spellCheck='false' onChange={(e) => getAddresses(e.target.value)} defaultValue={typeof address !== 'undefined' ? address.line1 : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
              <div className={"border-l border-r border-neutral-300 z-10 absolute w-full max-h-56 overflow-auto bg-white opacity-0 group-focus-within:opacity-100 " + (addresses.length > 0 && "border-b")}>
                <ul>
                  {
                    addresses.map((address) => {
                      return (
                        <li className="ps-4 py-2 hover:bg-neutral-100 cursor-pointer" onClick={() => updateFields(address.adresse)}>{address.tekst}</li>
                      )
                    })
                  }
                </ul>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="title w-full flex flex-col gap-2">
              <p className="flex-[1] font-medium">Postnummer</p>
              <div className="w-full flex-[1] relative">
                <input type="text" id="postal_code" autoComplete='none' disabled defaultValue={typeof address !== 'undefined' ? address.postal_code : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
              </div>
            </div>
            <div className="title w-full flex flex-col gap-2">
              <p className="flex-[1] font-medium">By</p>
              <div className="w-full flex-[1] relative">
                <input type="text" id="city" autoComplete='none' disabled defaultValue={typeof address !== 'undefined' ? address.city : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="text-sm font-medium text-gray-900">Køberens muligheder</h2>
        <div className="flex flex-col gap-y-2">
          <div className="border border-neutral-300 p-4 px-5 md:px-10 flex justify-between items-center gap-5">
            <div className="flex flex-col">
              <h2 className="font-semibold">
                Forsendelse med DAO
              </h2>
              <p className="text-sm text-neutral-600">Køberen betaler forsendelsen - og vi står for oprettelse af pakkelabel.</p>
            </div>
            <div className="img w-10 min-w-8">
              <img src={dao} className="h-full w-full object-contain" />
            </div>
          </div>
          <label for="pickup" className="border border-neutral-300 options flex justify-between cursor-pointer p-4 px-5 md:px-10">
            <div className={"flex flex-col" + (pickup !== false ? "" : " opacity-50 cursor pointer-events-none")}>
              <h2 className="font-semibold">
                Afhentning på din adresse
              </h2>
              <p className="text-sm text-neutral-600">Din fulde addresse deles kun med den endelige køber.</p>
            </div>
            <div className="flex items-center">
                <input
                        className="h-3.5 w-10 appearance-none rounded-[0.4375rem] bg-neutral-300 after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.275rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:bg-emerald-600"
                        type="checkbox"
                        role="switch"
                        name="pickup"
                        id="pickup"
                        onClick={() => setPickup((pickup === true) ? false : true)}
                        checked={pickup === true} />
            </div>
          </label>
        </div>
      </div>
    </div>
  )
}